<div class="social-media-bar-container">
  <ng-container *ngFor="let media of socialMedia">
    <ng-container [ngSwitch]="media.type">
      <a
        *ngSwitchCase="SocialMedia.Facebook"
        [href]="media.href"
        class="facebook"
        target="_blank"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
      <a
        *ngSwitchCase="SocialMedia.Instagram"
        [href]="media.href"
        target="_blank"
        class="instagram"
      >
        <i class="fab fa-instagram"></i>
      </a>
      <a
        *ngSwitchCase="SocialMedia.LinkedIn"
        [href]="media.href"
        target="_blank"
        class="linkedin"
      >
        <i class="fab fa-linkedin"></i>
      </a>
      <a
        *ngSwitchCase="SocialMedia.Twitter"
        [href]="media.href"
        target="_blank"
        class="twitter"
      >
        <i class="fab fa-twitter"></i>
      </a>
      <a
        *ngSwitchCase="SocialMedia.YouTube"
        [href]="media.href"
        target="_blank"
        class="youtube"
      >
        <i class="fab fa-youtube"></i>
      </a>
    </ng-container>
  </ng-container>
</div>
